import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import useFormExample from './hooks/useFormExample'
import Textbox, { ViewTextboxProps } from '../control/Textbox'
import NumberTextbox, { ViewNumberTextboxProps } from '../control/NumberTextbox'
import Textarea, { ViewTextareaProps } from '../control/Textarea'
import formatString from 'format-string-by-pattern'
import { formatTextbox } from '../constant/FormatString'
import Grid from '@mui/material/Grid'
import FormHelperText from '@mui/material/FormHelperText'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import numeral from 'numeral'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(4),
        overflow: 'auto',
        height: '-webkit-fill-available',
    },
}))

const FormExample = () => {
    const formExample = useFormExample()
    const { t } = useTranslation()
    const classes = useStyles()
    const required = (value: any) => (value ? undefined : 'Required')

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item md={12}>
                    <Typography variant="h3" gutterBottom>
                        Form example
                    </Typography>
                    <Divider />
                </Grid>
                <Grid item md={12}>
                    <FinalForm
                        onSubmit={formExample.onSubmit}
                        initialValues={{}}
                        validate={(values) => {
                            let errors: any = {}
                            if (values.textbox !== 'foo') {
                                errors.textbox = 'foooooooooooooooooooooooooooooooo'
                            }

                            const english = /^[A-Za-z0-9]*$/
                            if (!english.test(values.textbox)) {
                                errors.textbox = 'Required'
                            }
                            return errors
                        }}
                    >
                        {(props) => (
                            <form onSubmit={props.handleSubmit}>
                                <Grid container spacing={1}>
                                    <Grid item md={12}>
                                        <Grid container spacing={1}>
                                            <Grid item md={12}>
                                                <ViewTextboxProps />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="textbox"
                                                    label="Textbox"
                                                    placeholder={t('LABEL.TEXT_REQUIRED')}
                                                    component={Textbox}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="textbox2"
                                                    label="Textbox Set Format"
                                                    component={Textbox}
                                                    parse={formatString(formatTextbox.phoneTH)}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="textbox3"
                                                    label="Textbox disabled"
                                                    placeholder="disabled"
                                                    component={Textbox}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <Field
                                                    name="textbox4"
                                                    label="Textbox fullWidth"
                                                    component={Textbox}
                                                    fullWidth
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item md={12}>
                                        <Grid container spacing={1}>
                                            <Grid item md={12}>
                                                <ViewNumberTextboxProps />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="numberTextbox"
                                                    label="Number Textbox"
                                                    inputType="number"
                                                    component={NumberTextbox}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="numberTextbox2"
                                                    label="Number Textbox disabled"
                                                    placeholder="disabled"
                                                    inputType="number"
                                                    component={NumberTextbox}
                                                    disabled
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <Field
                                                    name="numberTextbox3"
                                                    label="Number Textbox fullWidth"
                                                    component={NumberTextbox}
                                                    fullWidth
                                                    required
                                                    formatOnBlur={true}
                                                    format={(value: any, name: string) =>
                                                        numeral(value).format('0,0.00')
                                                    }
                                                />
                                            </Grid>
                                            <Grid item md={12}>
                                                <FormHelperText id="component-helper-text" error={true}>
                                                    *** กำลังปรับปรุง
                                                </FormHelperText>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item md={12}>
                                        <Grid container spacing={1}>
                                            <Grid item md={12}>
                                                <ViewTextareaProps />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="textarea"
                                                    label="Textarea"
                                                    placeholder={t('LABEL.TEXT_REQUIRED')}
                                                    component={Textarea}
                                                    required
                                                />
                                            </Grid>
                                            <Grid item md={3}>
                                                <Field
                                                    name="textarea2"
                                                    label="Textarea fullWidth"
                                                    component={Textarea}
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="textarea3"
                                                    label="Textarea set row"
                                                    placeholder="disabled"
                                                    component={Textarea}
                                                    rows={10}
                                                    disabled
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item md={12}>
                                        <Grid container spacing={1}>
                                            <Grid item md={12}>
                                                <ViewTextareaProps />
                                            </Grid>
                                            <Grid item>
                                                <Field
                                                    name="autocomplete"
                                                    label="Autocomplete"
                                                    placeholder={t('LABEL.TEXT_REQUIRED')}
                                                    component={Textbox}
                                                    required
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item md={12}>
                                        <Divider />
                                    </Grid>
                                    <Grid item md={12}>
                                        <button type="submit">Submit</button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </FinalForm>
                </Grid>
            </Grid>
        </div>
    )
}

export default FormExample
